import { calculateAge } from './date'
import { Feature } from '~/plugins/feature-flags'
import { REFERRAL_PROGRAM_ON } from '~/plugins/feature-flags/variants'

export interface ReferralProgramConditions {
  isAgeValid: boolean
  isReferralProgramOn: boolean
  isPro: boolean
}

export const getReferralProgramConditions = (user: any, featureFlags: any): ReferralProgramConditions => {
  const age = calculateAge(user.profile.dateOfBirth)
  const isReferralProgramOn = featureFlags?.getVariant(Feature.ReferralProgram).name === REFERRAL_PROGRAM_ON
  const isPro = !!user.membership && !user.membership?.freemium && !user.membership?.freeTrial

  return {
    isAgeValid: parseInt(age) >= 18,
    isReferralProgramOn,
    isPro
  }
}

export const isReferralProgramVisible = (user: any, featureFlags: any): boolean => {
  const conditions = getReferralProgramConditions(user, featureFlags)

  return (
    conditions.isReferralProgramOn &&
    conditions.isAgeValid &&
    conditions.isPro
  )
}
